  <h1 mat-dialog-title>{{data.dialogTitle | translate}}</h1>
  <div mat-dialog-content>
    <p class="dialog-content">{{data.dialogText | translate: {type: data.codeType} }} <br> {{data.dialogActions | translate}}</p>
    <p class="dialog-warning">{{data.dialogPrecision | translate}}</p>
  </div>
  <div mat-dialog-actions>
    <button *ngIf="data.iscancel" gs1Button [name]="'dialog-cancel'" [appearance]="'outlined'" (click)="onNoClick()">{{data.dialogButtonCancel | translate}}</button>
    <button gs1Button [name]="'dialog-confirm'" [mat-dialog-close]="true" cdkFocusInitial>{{data.dialogButtonConfirm | translate}}</button>
  </div>